import { graphql } from '@predium/client-graphql';

export const GET_FOLDER_CHILDREN = graphql(`
  query GetDriveFolderChildren($parentIds: [Int!]!) {
    getFolderChildren(parentIds: $parentIds) {
      folders {
        id
        name
        parentId
        folderTypeId
        childCount
        buildingId
        portfolioId
        economicUnitId
      }
    }
  }
`);

export const GET_ROOT_FOLDER_FOR_TREE = graphql(`
  query GetDriveRootFolderForTree {
    getRootFolderForTree {
      rootFolder {
        id
        name
        parentId
        folderTypeId
        childCount
        buildingId
        portfolioId
        economicUnitId
      }
    }
  }
`);

export const GET_BUILDING_FOLDER = graphql(`
  query GetBuildingFolder($buildingId: Int!) {
    getBuildingFolder(buildingId: $buildingId) {
      folderId
    }
  }
`);

export const GET_FOLDER_CONTENTS = graphql(`
  query GetDriveFolderContents($folderId: Int!) {
    getFolderContents(folderId: $folderId) {
      folders {
        id
        name
        parentId
        orgId
        folderTypeId
        portfolioId
        economicUnitId
        buildingId
        createdAt
        updatedAt
        childFolderCount
        fileCount
      }
      fileMemberships {
        id
        fileId
        folderId
        createdAt
        file {
          id
          name
          createdAt
          uploading
          energyCertificates {
            id
            buildingId
            buildingDraftId
          }
          consumptionInvoices {
            id
            buildingId
          }
          emissionCertificates {
            id
          }
          energyCertificateDrafts {
            id
            buildingDraft {
              id
            }
          }
          consumptionInvoiceDrafts {
            id
            buildingId
          }
          emissionCertificateDrafts {
            id
          }
        }
      }
    }
  }
`);

export const GET_FOLDER_BREADCRUMB = graphql(`
  query GetDriveFolderBreadcrumb($folderId: Int!) {
    getFolderBreadcrumb(folderId: $folderId) {
      breadcrumb {
        id
        name
        folderTypeId
      }
    }
  }
`);

export const GET_DRIVE_FAVORITES = graphql(`
  query GetDriveFavorites {
    getDriveFavorites {
      favorites {
        id
        kind
        folderId
        name
        folderTypeId
        fileId
      }
    }
  }
`);

export const SEARCH_DRIVE = graphql(`
  query SearchDrive($query: String!, $limit: Int) {
    searchDrive(query: $query, limit: $limit) {
      folders {
        id
        name
        folderTypeId
        path
      }
      files {
        fileId
        folderId
        name
        path
      }
    }
  }
`);
